// Single source of truth for ROUT operational priority (P1–P5) wording & styling.
// Import from here everywhere so labels/colors never drift again.
export const PRIORITY_KEYS = ['P1', 'P2', 'P3', 'P4', 'P5'];

export const PRIORITY_SLA = {
  P1: 'Within 2 Hours',
  P2: 'Same Day',
  P3: 'Same Week',
  P4: 'Within 30 Days',
  P5: 'Special Project',
};

export const PRIORITY_LABELS = Object.fromEntries(
  Object.entries(PRIORITY_SLA).map(([p, t]) => [p, `${p} — ${t}`])
);

export const PRIORITY_OPTIONS = Object.entries(PRIORITY_LABELS).map(([value, label]) => ({ value, label }));

export const priorityLabel = (p) => PRIORITY_LABELS[p] || p || '—';

// Solid pill/badge treatment (borders) — used on Work Order detail headers.
const PRIORITY_BADGE = {
  P1: 'bg-red-100 text-red-700 border-red-200',
  P2: 'bg-orange-100 text-orange-700 border-orange-200',
  P3: 'bg-amber-100 text-amber-800 border-amber-200',
  P4: 'bg-blue-100 text-blue-700 border-blue-200',
  P5: 'bg-purple-100 text-purple-700 border-purple-200',
};
export const priorityBadgeClass = (p) => PRIORITY_BADGE[p] || 'bg-slate-100 text-slate-600 border-slate-200';

// Solid dot/tag background — used on the compact Field work-order tags.
const PRIORITY_DOT = {
  P1: 'bg-red-600', P2: 'bg-orange-500', P3: 'bg-amber-500', P4: 'bg-blue-500', P5: 'bg-purple-500',
};
export const priorityDotClass = (p) => PRIORITY_DOT[p] || 'bg-slate-500';
